import * as C from '../constants';

export default {
  /**
   * @param state
   */
  [C.REQUEST_INITIATE_SETUP_PENDING](state) {
    state.filter = {
      ...state.filter,
      loading: true,
      error: false,
      noContent: false,
    };
  },
  /**
   * @param state
   * */
  [C.REQUEST_INITIATE_SETUP_SUCCESS](state) {
    state.filter = {
      ...state.filter,
      loading: false,
      error: false,
    };
  },
  /**
   * @param state
   */
  [C.REQUEST_INITIATE_SETUP_FAILURE](state) {
    state.filter = {
      ...state.filter,
      loading: false,
      error: true,
      noContent: false,
    };
  },
  /**
   * @param state
   */
  [C.REQUEST_TYPES_LIST_PENDING](state) {
    state.filter = {
      ...state.filter,
      loading: true,
    };
  },
  /**
   * @param state
   * @param payload
   */
  [C.REQUEST_TYPES_LIST_SUCCESS](state, payload) {
    state.requests = {
      ...state.requests,
      requestTypes: payload,
    };
  },
  /**
   * @param state
   */
  [C.REQUEST_TYPES_LIST_FAILURE](state) {
    state.filter = {
      ...state.filter,
      error: true,
    };
  },
  /**
   * @param state
   */
  [C.REQUEST_TYPES_NO_CONTENT](state) {
    state.filter = {
      ...state.filter,
      error: false,
      noContent: true,
    };
  },
  /**
   * @param state
   */
  [C.REQUESTS_CHANNEL_LIST_PENDING](state) {
    state.filter = {
      ...state.filter,
      loading: true,
    };
  },
  /**
   * @param state
   * @param payload
   */
  [C.REQUESTS_CHANNEL_LIST_SUCCESS](state, payload) {
    state.requests = {
      ...state.requests,
      channels: payload,
    };
  },
  /**
   * @param state
   */
  [C.REQUESTS_CHANNEL_LIST_FAILURE](state) {
    state.filter = {
      ...state.filter,
      error: true,
    };
  },
  /**
   * @param state
   */

  [C.REQUESTS_LIST_PENDING](state) {
    state.requests = {
      ...state.requests,
      loading: true,
      error: false,
      noContent: false,
      items: [],
    };
  },
  /**
   * @param state
   * @param requests
   * @param products
   */
  [C.REQUESTS_LIST_SUCCESS](state, { requests, products }) {
    state.requests = {
      ...state.requests,
      loading: false,
      error: false,
      noContent: false,
      items: requests,
      products,
    };
  },
  /**
   * @param state
   */
  [C.REQUESTS_LIST_FAILURE](state) {
    state.requests = {
      ...state.requests,
      loading: false,
      error: true,
      noContent: false,
    };
  },
  /**
   * @param state
   */
  [C.REQUESTS_LIST_NO_CONTENT](state) {
    state.requests = {
      ...state.requests,
      loading: false,
      error: false,
      noContent: true,
      items: [],
    };
  },
  /**
   * @param state
   * @param payload
   */
  [C.REQUESTS_FILTER_SEARCH](state, payload) {
    state.filter = {
      ...state.filter,
      search: payload.searchBookingId,
      requestType: payload.requestType,
      channels: payload.channel,
    };
  },
  /**
   * @param state
   * @param payload
   */
  [C.REQUESTS_SET_REQUEST](state, payload) {
    state.requestLogFilesList = {
      ...state.requestLogFilesList,
      request: payload,
      show: state.requestLogFilesList.show += 1,
    };
  },
  /**
   * @param state
   */
  [C.REQUESTS_RESET_REQUEST](state) {
    state.requestLogFilesList = {
      ...state.requestLogFilesList,
      items: [],
      request: [],
    };
  },
  /**
   * @param state
   * @param payload
   */
  [C.REQUESTS_SET_PAGINATION_INDEX](state, payload) {
    state.filter = {
      ...state.filter,
      paginationIndex: payload,
    };
  },
  /**
   * @param state
   */
  [C.REQUESTS_UPDATE_PAGINATION_INDEX](state) {
    state.filter = {
      ...state.filter,
      paginationIndex: state.filter.paginationIndex += 1,
      loadNewPage: state.filter.loadNewPage += 1,
    };
  },
  /**
   * @param state
   */
  [C.REQUESTS_RESET_PAGINATION_INDEX](state) {
    state.filter = {
      ...state.filter,
      paginationIndex: 1,
    };
  },
  /**
   * @param state
   */
  [C.REQUEST_LOG_FILES_LIST_PENDING](state) {
    state.requestLogFilesList = {
      ...state.requestLogFilesList,
      loading: true,
      error: false,
      noContent: false,
    };
  },
  /**
   * @param state
   * @param payload
   */
  [C.REQUEST_LOG_FILES_LIST_SUCCESS](state, payload) {
    state.requestLogFilesList = {
      ...state.requestLogFilesList,
      loading: false,
      error: false,
      noContent: false,
      items: payload,
    };
  },
  /**
   * @param state
   */
  [C.REQUEST_LOG_FILES_LIST_FAILURE](state) {
    state.requestLogFilesList = {
      ...state.requestLogFilesList,
      loading: false,
      error: true,
      noContent: false,
    };
  },
  /**
   * @param state
   */
  [C.REQUEST_LOG_FILES_LIST_NO_CONTENT](state) {
    state.requestLogFilesList = {
      ...state.requestLogFilesList,
      loading: false,
      noContent: true,
    };
  },
  /**
   * @param state
   */
  [C.REQUESTS_DOMAINS_LIST_PENDING](state) {
    state.filter = {
      ...state.filter,
      loading: true,
    };
  },
  /**
   * @param state
   */
  [C.REQUESTS_DOMAINS_LIST_FAILURE](state) {
    state.filter = {
      ...state.filter,
      error: true,
    };
  },
  /**
   * @param state
   * @param payload
   */
  [C.REQUESTS_DOMAINS_LIST_SUCCESS](state, payload) {
    state.requests = {
      ...state.requests,
      domains: payload,
    };
  },
};




// WEBPACK FOOTER //
// ./src/store/modules/requestStatus/mutations.js